import {
  LOGIN,
  LOGOUT,
  GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER,
  UPDATE_PROFILE_DETAILS,
  RESET_PASSWORD,
} from 'src/redux/Actions/Type';

const token = localStorage.getItem('token');
const userData = token ? JSON.parse(localStorage.getItem('userData')) : null;
const superAdmin = token
  ? localStorage.getItem('superAdmin') === 'true'
  : false;
const organisationAdmin = token
  ? localStorage.getItem('organisationAdmin') === 'true'
  : false;
const normalUser = token
  ? localStorage.getItem('normalUser') === 'true'
  : false;
const userType = token ? localStorage.getItem('userType') : null;
const userRole = token ? localStorage.getItem('userRole') : null;
const firstStageAssigned = token
  ? localStorage.getItem('showVehicleTrackingCreate') === 'true'
  : false;
const getInitialState = (isToken) => {
  let initialState;
  if (isToken) {
    initialState = {
      isLoggedIn: true,
      token,
      userData,
      superAdmin,
      organisationAdmin,
      normalUser,
      userType,
      userRole,
      firstStageAssigned,
      resetPasswordResponse: {},
      assignedPermissionsForCurrentUser: null,
    };
  } else {
    initialState = {
      isLoggedIn: false,
      token: null,
      userData: null,
      superAdmin: false,
      organisationAdmin: false,
      normalUser: false,
      userType: null,
      userRole: null,
      firstStageAssigned: false,
      resetPasswordResponse: {},
      assignedPermissionsForCurrentUser: null,
      updateProfileDetails: {},
    };
  }
  return initialState;
};
const initialState = getInitialState(token);

const auth = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.token,
        userData: payload.userdata,
        superAdmin: payload.superAdmin,
        organisationAdmin: payload.organisationAdmin,
        normalUser: payload.normalUser,
        userType: payload.userType,
        userRole: payload.userRole,
        firstStageAssigned: payload.firstStageAssigned,
      };

    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        userData: null,
        superAdmin: false,
        organisationAdmin: false,
        normalUser: false,
        userType: null,
        userRole: null,
      };
    case RESET_PASSWORD:
      return {
        ...state,
        resetPasswordResponse: payload,
      };
    case GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER:
      return {
        ...state,
        assignedPermissionsForCurrentUser: payload,
      };
    case UPDATE_PROFILE_DETAILS:
      return {
        ...state,
        updateProfileDetails: payload,
      };

    default:
      return state;
  }
};

export default auth;
